var _InputAdornment;
var _excluded = ["buttonContents", "buttonTooltip", "classes", "className", "didSelectionChange", "isLoading", "items", "labels", "minimumCharacters", "onExpandItem", "onSearch", "onSelectItem", "PopoverProps", "selectedItem", "showSearch"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { array, bool, func, node, number, object, string } from 'prop-types';
import clsx from 'clsx';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import { Search as ActionSearch } from 'mosaic-react-icons';
import { alpha, styled } from '@mui/material/styles';
import debounce from 'lodash.debounce';
import { SovosTreeList } from '../../../sovos-tree-list';
import SovosTextField from '../../../sovos-text-field';
import SovosFixedWidthText from '../../../sovos-fixed-width-text';
import SovosResizeContainer from '../../../sovos-resize-container';
import SovosTooltip from '../../../sovos-tooltip';
import useMosaicTranslation from '../../i18n/useMosaicTranslation';
var ToggleButton = styled(Button)(function (_ref) {
  var palette = _ref.theme.palette;
  return {
    borderRadius: 0,
    padding: 0,
    textTransform: 'none',
    width: '100%',
    '&.Mui-focusVisible': {
      color: alpha(palette.primary.contrastText, 0.4)
    }
  };
});
var SearchWrapper = styled('div')(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    margin: "0 ".concat(spacing(), " ").concat(spacing(), " ").concat(spacing())
  };
});
var Search = styled(SovosTextField)(function (_ref3) {
  var spacing = _ref3.theme.spacing;
  return {
    '&.MuiTextField-root': {
      minHeight: 'auto'
    },
    '& .MuiInputBase-adornedStart': {
      paddingLeft: spacing()
    }
  };
});
var StyledPopover = styled(Popover)(function (_ref4) {
  var spacing = _ref4.theme.spacing;
  return {
    '&.sovosSwitcher__popover--showSearch .MuiPopover-paper': {
      paddingTop: spacing(2)
    },
    '& .MuiPopover-paper': {
      maxWidth: spacing(60),
      minWidth: spacing(30),
      paddingTop: spacing(1),
      paddingBottom: spacing()
    }
  };
});
var TreeListWrapper = styled('div')({
  maxHeight: 'calc(100vh - 240px)',
  overflow: 'auto'
});
var NoResults = styled('div')(function (_ref5) {
  var _ref5$theme = _ref5.theme,
    palette = _ref5$theme.palette,
    spacing = _ref5$theme.spacing,
    typography = _ref5$theme.typography;
  return _objectSpread(_objectSpread({}, typography.body1), {}, {
    alignItems: 'center',
    color: palette.text.secondary,
    display: 'flex',
    height: spacing(5),
    justifyContent: 'center',
    margin: spacing()
  });
});
var defaultDidSelectionChange = function defaultDidSelectionChange(currentSelection, newSelection) {
  return currentSelection.id !== newSelection.id;
};
var Switcher = function Switcher(_ref6) {
  var buttonContents = _ref6.buttonContents,
    buttonTooltip = _ref6.buttonTooltip,
    classes = _ref6.classes,
    className = _ref6.className,
    didSelectionChange = _ref6.didSelectionChange,
    isLoading = _ref6.isLoading,
    items = _ref6.items,
    labels = _ref6.labels,
    minimumCharacters = _ref6.minimumCharacters,
    onExpandItem = _ref6.onExpandItem,
    onSearch = _ref6.onSearch,
    onSelectItem = _ref6.onSelectItem,
    PopoverProps = _ref6.PopoverProps,
    selectedItem = _ref6.selectedItem,
    showSearch = _ref6.showSearch,
    rest = _objectWithoutProperties(_ref6, _excluded);
  var _useMosaicTranslation = useMosaicTranslation(),
    t = _useMosaicTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchInput = _useState2[0],
    setSearchInput = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var buttonRef = useRef(null);
  var _useState5 = useState(items),
    _useState6 = _slicedToArray(_useState5, 2),
    filteredItems = _useState6[0],
    setFilteredItems = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    searchTriggered = _useState8[0],
    setSearchTriggered = _useState8[1];
  var isDisabled = !onSearch && !(items.length > 1 || items[0].nestedItems);
  var searchMessage = "".concat(minimumCharacters, " ").concat((labels === null || labels === void 0 ? void 0 : labels.searchTemplate) || t('autocomplete.helpMessageTemplate'));
  useEffect(function () {
    // If the items have changed or the loading flag has changed, clear the search trigger
    if (isLoading || items) {
      setSearchTriggered(false);
      setFilteredItems(items);
    }
  }, [isLoading, items]);
  var getItems = function getItems() {
    if (onSearch) {
      return items;
    }
    return filteredItems;
  };
  var itemMatches = function itemMatches(item, value) {
    var itemName = item.name.toUpperCase();
    var searchString = value.toUpperCase();
    return !!itemName.includes(searchString);
  };
  var getExpandedIds = function getExpandedIds() {
    // Get items that have been filtered
    var listItems = getItems();
    if (!listItems || !listItems.length || !searchInput || searchTriggered) {
      return undefined;
    }
    var itemsToExpand = new Set();
    var getItemsToExpand = function getItemsToExpand(item) {
      var result = false;
      if (itemMatches(item, searchInput) && !item.nestedItems) {
        result = true;
      }
      if (item.nestedItems) {
        var filtered = item.nestedItems.filter(function (nested) {
          return getItemsToExpand(nested, result) || itemMatches(nested, searchInput);
        });
        if (filtered.length) result = true;
      }
      if (result) itemsToExpand.add(item.id);
      return result;
    };
    listItems.forEach(function (item) {
      return getItemsToExpand(item);
    });
    return Array.from(itemsToExpand);
  };

  // Filter search values, calculating items to include and items to expand.
  var search = function search(value) {
    if (!value) {
      setFilteredItems(items);
      return;
    }
    if (value.length < minimumCharacters) return;
    if (onSearch) {
      onSearch(value);
      return;
    }
    var filteredResults = function filteredResults(arr) {
      var filtered = arr.reduce(function (matches, item) {
        var nestedItems = item.nestedItems;
        if (itemMatches(item, value)) {
          matches.push(item);
        } else if (nestedItems && nestedItems.length) {
          var nestedResults = filteredResults(nestedItems);
          if (nestedResults.length) {
            matches.push(_objectSpread(_objectSpread({}, item), {}, {
              nestedItems: nestedResults
            }));
          }
        }
        return matches;
      }, []);
      return filtered;
    };
    var results = filteredResults(items);
    setFilteredItems(results);
    setSearchTriggered(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var handleSearchValue = useCallback(debounce(function (value) {
    return search(value);
  }, 500), [items]);
  var handleSearchInput = function handleSearchInput(event) {
    var value = event.target.value;
    setSearchInput(value);
    if (onSearch && value.length >= minimumCharacters) {
      setSearchTriggered(true);
    } else if (!onSearch) {
      setSearchTriggered(true);
    }
    handleSearchValue(value);
  };
  var handleButtonClick = function handleButtonClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var getButtonContent = function getButtonContent() {
    if (_typeof(buttonContents) === 'object') {
      return buttonContents;
    }
    return /*#__PURE__*/React.createElement(SovosFixedWidthText, {
      text: buttonContents,
      style: {
        flex: '1 0 auto'
      }
    });
  };
  var handleSelectItem = function handleSelectItem(item) {
    if (!didSelectionChange(selectedItem, item)) {
      return;
    }
    onSelectItem(item);
    setAnchorEl(null);
  };
  var renderNoResults = function renderNoResults() {
    var message;
    if (isLoading || searchTriggered) {
      message = (labels === null || labels === void 0 ? void 0 : labels.loading) || t('autocomplete.loadingMessage');
    } else if (onSearch && (!searchInput || searchInput.length < minimumCharacters)) {
      message = searchMessage;
    } else {
      message = (labels === null || labels === void 0 ? void 0 : labels.noResults) || t('noResults');
    }
    return /*#__PURE__*/React.createElement(NoResults, {
      className: clsx('sovosSwitcher__noResults', classes === null || classes === void 0 ? void 0 : classes.noResults)
    }, message);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var renderPopover = function renderPopover() {
    var expanded = getExpandedIds();
    var listItems = getItems();
    return /*#__PURE__*/React.createElement(StyledPopover, _extends({
      anchorOrigin: {
        horizontal: 0,
        vertical: 'bottom'
      },
      anchorEl: anchorEl,
      classes: {
        paper: classes === null || classes === void 0 ? void 0 : classes.popoverPaper
      },
      className: clsx('sovosSwitcher__popover', showSearch && 'sovosSwitcher__popover--showSearch'),
      "data-testid": "sovosSwitcher__popover",
      marginThreshold: 0,
      onClose: handleClose,
      open: !!anchorEl,
      transformOrigin: {
        horizontal: 'left',
        vertical: 'top'
      }
    }, PopoverProps), /*#__PURE__*/React.createElement(SovosResizeContainer, null, showSearch && /*#__PURE__*/React.createElement(SearchWrapper, {
      className: classes === null || classes === void 0 ? void 0 : classes.search
    }, /*#__PURE__*/React.createElement(Search, {
      autoFocus: true,
      fullWidth: true,
      InputProps: {
        classes: {
          adornedStart: classes === null || classes === void 0 ? void 0 : classes.searchFieldAdornment
        },
        startAdornment: _InputAdornment || (_InputAdornment = /*#__PURE__*/React.createElement(InputAdornment, {
          position: "start"
        }, /*#__PURE__*/React.createElement(ActionSearch, null)))
      },
      onChange: handleSearchInput,
      placeholder: t('search'),
      size: "small",
      value: searchInput,
      variant: "outlined"
    })), listItems && listItems.length && !(onSearch && (isLoading || searchTriggered)) ? /*#__PURE__*/React.createElement(TreeListWrapper, {
      className: classes === null || classes === void 0 ? void 0 : classes.treeListWrapper
    }, /*#__PURE__*/React.createElement(SovosTreeList, {
      key: expanded && expanded.toString(),
      data: listItems,
      initialExpandedItems: expanded,
      initialSelectedItem: selectedItem.id,
      onItemClick: handleSelectItem,
      onItemExpanded: onExpandItem
    })) : renderNoResults()));
  };
  var renderButton = function renderButton() {
    var button = /*#__PURE__*/React.createElement(ToggleButton, {
      classes: {
        root: classes === null || classes === void 0 ? void 0 : classes.toggleButton,
        focusVisible: classes === null || classes === void 0 ? void 0 : classes.toggleButtonFocus
      },
      className: "sovosSwitcher__button",
      "data-testid": "sovosSwitcher__button",
      disabled: isDisabled,
      fullWidth: true,
      onClick: handleButtonClick
    }, getButtonContent());
    if (buttonTooltip && !isDisabled) {
      return /*#__PURE__*/React.createElement(SovosTooltip, {
        title: buttonTooltip
      }, /*#__PURE__*/React.createElement("div", null, button));
    }
    return button;
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx('sovosSwitcher', className, classes === null || classes === void 0 ? void 0 : classes.root),
    ref: buttonRef
  }, rest), renderButton(), renderPopover());
};
Switcher.propTypes = {
  buttonContents: node.isRequired,
  buttonTooltip: string,
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  didSelectionChange: func,
  isLoading: bool,
  items: array.isRequired,
  labels: object,
  minimumCharacters: number,
  onExpandItem: func,
  onSelectItem: func.isRequired,
  onSearch: func,
  PopoverProps: object,
  selectedItem: object.isRequired,
  showSearch: bool
};
Switcher.defaultProps = {
  buttonTooltip: undefined,
  classes: undefined,
  className: undefined,
  didSelectionChange: defaultDidSelectionChange,
  isLoading: false,
  labels: undefined,
  minimumCharacters: 2,
  onExpandItem: undefined,
  onSearch: undefined,
  PopoverProps: {},
  showSearch: false
};
export default Switcher;